import { outdent } from 'outdent';

export const skillDocs = outdent`
## Skills

This project comes with a set of skills that can be used when the user asks for help with specific tasks.
If you're using the instructions provided by a skill and fail, or if you do not find a relevant skill for the task,
you can try updating the skills by running the following command:

\`wix skills update\`

This will update the skills to the latest version.
`;
